// Groups the webhook events the way the operator reads them, instead of one long list.
// The proposal pipeline group only exists for accounts with the Corban module active,
// and the backend refuses those events for every other account.
export const WEBHOOK_EVENT_GROUPS = [
  {
    key: 'CONVERSATIONS',
    icon: 'i-hugeicons-bubble-chat',
    events: [
      'conversation_created',
      'conversation_updated',
      'conversation_status_changed',
      'conversation_typing_on',
      'conversation_typing_off',
    ],
  },
  {
    key: 'MESSAGES',
    icon: 'i-hugeicons-message-01',
    events: ['message_created', 'message_updated'],
  },
  {
    key: 'CONTACTS',
    icon: 'i-hugeicons-user-multiple',
    events: ['contact_created', 'contact_updated'],
  },
  {
    key: 'CHANNELS',
    icon: 'i-hugeicons-connect',
    events: ['webwidget_triggered'],
    optionalEvents: { inbox_updated: 'inboxEvents' },
  },
  {
    key: 'PROPOSALS',
    icon: 'i-hugeicons-money-send-square',
    requires: 'proposalPipeline',
    events: [
      'proposal_created',
      'proposal_updated',
      'proposal_stage_changed',
      'proposal_status_changed',
    ],
  },
];

export const buildWebhookEventGroups = ({
  inboxEvents = false,
  proposalPipeline = false,
} = {}) => {
  const available = { inboxEvents, proposalPipeline };
  return WEBHOOK_EVENT_GROUPS.filter(
    group => !group.requires || available[group.requires]
  ).map(group => ({
    ...group,
    events: [
      ...group.events,
      ...Object.entries(group.optionalEvents || {})
        .filter(([, flag]) => available[flag])
        .map(([event]) => event),
    ],
  }));
};

export const webhookEventList = options =>
  buildWebhookEventGroups(options).flatMap(group => group.events);
